/**
 * Calculates the total count of selected filter options
 *
 * @param selectedFilters - An object containing filter groups, where each group contains boolean values
 * @returns The total count of selected filter options (true values) across all groups
 */
export const getGeneralFiltersSelectedOptionsCount = (
  selectedFilters: Record<string, Record<string, boolean>>,
): number => {
  return Object.values(selectedFilters).reduce((count, group) => {
    return count + Object.values(group).filter((val) => val).length;
  }, 0);
};

export const isSizeDimension = (dimensionId: string): boolean =>
  dimensionId === 'size_id';
